import React from "react";
import styled from "styled-components";
import {Button, TextGradient} from "../styles/globalStyles";
import {device} from "../styles/breakpoints";


const Wrapper = styled.div`
  margin-top:  ${({bl}) => bl ? '0' : '10vh'};

  display: flex;
  flex-direction: column;
  align-self: flex-start;
  border-left: ${({bl}) => bl ? '2px solid #fff' : 'none'};
  padding-left: ${({bl}) => bl ? '10px' : 'none'};
`;

const H1 = styled(TextGradient)`
  margin: 0;
  padding: 0;
  @media ${device.desktop} {
    font-size: 60px;
  }

`;

const H3 = styled.h3`
  margin: 0;
  padding: 0;
  @media ${device.desktop} {
    font-size: 20px;
  }
`;


const Title = ({h1, children, h3, isButtonShow,bl}) => {
  return (
    <Wrapper bl={bl}>
      {h3 ? <H3>{h3}</H3> : null}
      <H1 as='h1'>{h1}</H1>
      <p>{children}</p>
      {isButtonShow ? <Button as='button'>Learn more...</Button> : null}
    </Wrapper>
  )
}
export default Title;
